class OrderConfirmationPrintController {
    constructor($timeout, settings) {
        this.recipientHeader = this.isDelivery() ? settings.orderConfirmation.deliveryMessage : settings.orderConfirmation.pickupMessage;
        $timeout(() => window.print(), 0);
    }

    isDelivery() {
        return this.order.DeliveryMethod === 'Courier' || this.order.DeliveryMethod === 'TPCour';
    }
}

const orderConfirmationPrintControllerComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: ['$timeout', 'Settings', OrderConfirmationPrintController],
    template: require('./order-confirmation-print.component.html').trim(),
};

module.exports = {
    OrderConfirmationPrintController,
    orderConfirmationPrintControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-print.component.js